// extracted by mini-css-extract-plugin
export default {"btnSection":"styles_btnSection__ZQFpw","ReturnBtn":"styles_ReturnBtn__m35SA","HomeBtn":"styles_HomeBtn__sgs+m"};